<script lang="ts">
import OperatorGroup from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/OperatorGroup.vue"
import SelectFilter from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/Select.vue"
import DateFilter from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/Date.vue"
import DateRangeFilter from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/DateRange.vue"
import TextFilter from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/Text.vue"
import NumberFilter from "../../../packages/datakode/nuxt-datakode-utils/components/list/Filters/types/Number.vue"
import AutocompleteFilter from "./types/Autocomplete.vue"

export default {
    name: "BasicFilters",
    components: { TextFilter, DateFilter, AutocompleteFilter, SelectFilter, OperatorGroup, DateRangeFilter, NumberFilter },
    props: {
        translationName: { type: String, required: true },
        filters: { type: Array, required: true },
        filtersOverload: { type: Array, required: false, default: () => null },
    },
    emits: ["resetPagination", "loadData"],
    data() {
        return {
            filtersSetted: [], // SHOWN FILTERS
            isInitialized: false,
        }
    },
    computed: {
        query() {
            const filters = this.filtersSetted.filter(filter => filter.value)
            const query = {}

            // FORMAT QUERY TO BE ACCEPTED BY QS
            // for operators, format is {lte : value, gte : value}
            // Keys must be field's name
            filters.forEach((filter) => {
                let value = filter.value
                if (filter.operator && filter.availableOperators) {
                    const previousValue = value
                    value = {}
                    value[filter.operator] = previousValue
                }

                if (query[filter.name] && typeof query[filter.name] === "object") {
                    query[filter.name] = { ...query[filter.name], ...value }
                }
                else {
                    query[filter.name] = value
                }
            })
            return query
        },
        filtersInitDone() { // get filter that need to be initialized
            return this.filtersSetted.filter(filter => Object.prototype.hasOwnProperty.call(filter, "init")).map(filter => filter.init)
        },
    },
    watch: {
        filtersOverload() {
            this.filtersSetted = []
            this.initFilters()
        },
        filtersInitDone() {
            /* ------
          ICI EST RAFFRAICHI LA LISTE (loadData) LORSQU'IL Y A UNE VALEUR PAR DEFAUT DE L'API (initial_value) OU UN FILTRE DANS L'URL (?id=55)
          - Si un filtre a une valeur par défaut et est dans l'url, la valeur dans l'url va écrasé la valeur par défaut.
          - Lorsque tous les filtres sont initialisés avec leur valeur par défaut, le script ci-dessous va vérifié que tous les filtres sont bien initialisé (vérifie s'il n'y a pas de false en tant que clé init dans les filtres)
          et que la longueur des filtres avec une valeur au chargement soient égales aux filtres initialisés pour éviter de devoir charger plusieurs fois la liste.
          - Les filtres dates ne sont pas encore pris en compte dans l'initialisation.
          ------ */

            const defaultFiltersByUrl = Object.keys(this.$route.query)
            const defaultFiltersByValues = this.filtersSetted.filter(filter => filter.initial_value).map(filter => filter.name)
            let defaultKeys = defaultFiltersByUrl.concat(defaultFiltersByValues)
            defaultKeys = [...new Set(defaultKeys)] // Besoin de rendre l'array unique pour la comparaison des longueurs entre les filtres ayant du être initialisé et les filtres qui ont une valeur par défaut

            // IF EVERY URL KEYS HAS BEEN CHECK AND FINISHED
            if (!this.isInitialized && (defaultFiltersByUrl.length || defaultFiltersByValues.length)) {
                if (this.filtersInitDone.length === defaultKeys.length && !this.filtersInitDone.includes(false)) {
                    this.isInitialized = true // TO AVOID TO RELOAD QUERIES
                    if (this.filtersInitDone.length) {
                        this.$emit("loadData")
                    }
                }
            }
        },
    },
    mounted() {
        this.initFilters()
    },
    methods: {
        initFilters() {
            // INIT SHOWN FILTERS
            this.filters.forEach(async (filter) => {
                if (!this.filtersOverload || (this.filtersOverload && this.filtersOverload.includes(filter.name))) {
                    const defaultValue = filter.initial_value ? Array.isArray(filter.initial_value) ? filter.initial_value.map(item => `${item}`) : filter.initial_value : null
                    this.filtersSetted.push({ ...filter, value: defaultValue, operator: "eq" })
                }
            })

            // ORDER FILTERS BY OVERLOAD ORDER
            if (this.filtersOverload) {
                this.filtersSetted = this.filtersSetted.sort((a, b) => this.filtersOverload.indexOf(a.name) - this.filtersOverload.indexOf(b.name))
            }
        },
        resetFilters() {
            this.$refs.filters.reset()
            this.filtersSetted = this.filtersSetted.map(filter => ({ ...filter, value: null, operator: "eq" }))
            this.$emit("resetPagination")
            this.$emit("loadData")
        },
        clearFilter(filter: { loading: boolean, autocomplete_url: string, name: string }, item: { title: string, value: string }, i: number) {
            const index = this.filtersSetted.findIndex((f, index) => f.name === filter.name && i === index)
            // console.log('this.filtersSetted[index]', this.filtersSetted[index], item)
            if (this.filtersSetted[index].value) {
                if (!this.filtersSetted[index].multiple) {
                    this.filtersSetted[index].value = null
                }
                else {
                    this.filtersSetted[index].value = this.filtersSetted[index].value.filter(v => v !== item.value)
                }
            }
            else {
                this.filtersSetted[index].value = null
            }
        },
        updateOperator(filter, operator, i) {
            this.filtersSetted = this.filtersSetted.map((f, index) => f.name === filter.name && index === i ? { ...f, operator } : f)
        },
        updateFilters(filter, value, i) {
            // index === i if for duplication when there is operators
            this.filtersSetted = this.filtersSetted.map((f, index) => f.name === filter.name && index === i ? { ...f, value } : f)
        },
        updateFilterState(filter, i) {
            this.filtersSetted = this.filtersSetted.map((f, index) => f.name === filter.name && index === i ? { ...filter } : f)
            // console.log('updateFilterState', filter, this.filtersSetted)
        },
    },
}
</script>

<template>
    <v-form ref="filters">
        <v-row no-gutters>
            <v-col
                v-for="(filter, i) in filtersSetted"
                :key="i"
                cols="12"
                lg="3"
                md="4"
                sm="6"
                class="pa-2"
            >
                <OperatorGroup
                    :filter="filter"
                    :filters="filtersSetted"
                    :translation-name="translationName"
                    @update-operator="updateOperator(filter, $event, i)"
                    @add-filter="filtersSetted.splice(i + 1, 0, $event)"
                    @delete-filter="filtersSetted.splice(i, 1)"
                >
                    <template #input>
                        <SelectFilter
                            v-if="filter.available_values"
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filters="updateFilters(filter, $event, i)"
                            @clear-filter="clearFilter(filter, $event, i)"
                            @update-filter-state="updateFilterState($event, i)"
                        />
                        <AutocompleteFilter
                            v-else-if="filter.autocomplete_url"
                            :filter="filter"
                            :translation-name="translationName"
                            @clear-filter="clearFilter(filter, $event, i)"
                            @update-filter-state="updateFilterState($event, i)"
                        />
                        <DateFilter
                            v-else-if="filter.type === 'FiltersDate'"
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filters="updateFilters(filter, $event, i)"
                        />

                        <DateFilter
                            v-else-if="filter.type === 'FiltersDateTime'"
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filters="updateFilters(filter, $event, i)"
                        /> <!-- !TODO add time picker -->

                        <DateRangeFilter
                            v-else-if="filter.type === 'FiltersDateRange'"
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filters="updateFilters(filter, $event, i)"
                        />
                        <!-- vuetify.config.js need to enable all labsComponents or at least import { VNumberInput } from 'vuetify/labs/VNumberInput'  -->
                        <!-- https://vuetifyjs.com/en/components/number-inputs/ -->
                        <NumberFilter
                            v-else-if="filter.type === 'FiltersFloat' || filter.type === 'FiltersInt'"
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filter-state="updateFilterState($event, i)"
                        />
                        <TextFilter
                            v-else
                            :filter="filter"
                            :translation-name="translationName"
                            @update-filter-state="updateFilterState($event, i)"
                        />
                    </template>
                </OperatorGroup>
            </v-col>
            <slot />
        </v-row>
    </v-form>
</template>
